import convertible from './convertible.png';
import coupe from './coupe.png';
import crossover from './crossover.png';
import hatchback from './hatchback.png';
import hybrid from './hybrid.png';
import minivan from './minivan.png';
import sedan from './sedan.png';
import small from './small.png';
import sport from './sport.png';
import suv from './suv.png';
import truck from './truck.png';
import wagon from './wagon.png';

export default {
  convertible,
  coupe,
  crossover,
  hatchback,
  hybrid,
  minivan,
  sedan,
  small,
  sport,
  suv,
  truck,
  wagon,
};
